import React from 'react';
import { FormGroup, Label } from 'reactstrap';
import { AvField, AvInput } from 'availity-reactstrap-validation';
import i18n from '../../../i18next';
import { convertStringToBoolean } from '../../../utils/CommonUtils';

/**
 * MUST always be rendered in an AvForm !!
 */
const FieldsTemplate = props => {

    if (!props.fields || props.fields === '{}') return null;

    const { inputGroupStyle, labelStyle, inputStyle, fieldContainer } = styles;
    const { fields, update } = props;

    return (
        <div style={fieldContainer}>
            {
                Object.keys(fields).map(key => {

                    return (
                        <FormGroup key={key} style={key === 'disableCreditBalanceOption' ? {...inputGroupStyle, width: 'auto', position: 'relative'} : inputGroupStyle}>
                            <Label style={labelStyle}>
                                {i18n.t(`screens:deliveryPartnerScreen.fields.${key}`)}
                            </Label>
                            {
                                key === 'disableCreditBalanceOption' ?
                                <AvInput 
                                    type="checkbox" 
                                    name="disableCreditBalanceOption"
                                    required={false}
                                    value={convertStringToBoolean(fields[key])}
                                    checked={convertStringToBoolean(fields[key])}
                                    onChange={update} 
                                    style={{right: '15px', top: '20px'}}/> :

                                <AvField style={inputStyle}
                                    type={key === 'password' ? 'password' : 'text'}
                                    name={key}
                                    value={fields[key]}
                                    onChange={update}
                                    errorMessage={i18n.t('common:validations.errorMsg')}
                                    required>
                                </AvField>
                            }
                        </FormGroup>
                    );
                })
            }
        </div>
    );
}

export default FieldsTemplate;

const styles = {
    inputGroupStyle: {
        width: '285px',
        paddingTop: "10px",
        display: 'flex',
        marginBottom: 0
    },
    labelStyle: {
        padding: '10px 35px 0 0'
    },
    inputStyle: {
        // width: '60%'
    },
    fieldContainer: {
        display: 'flex',
        flexWrap: 'wrap',
        paddingLeft: '20px'
    },
}


// WEBPACK FOOTER //
// ./src/components/common/stringTemplateRenderer/FieldsTemplate.js